import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import TitleH2 from './TextSupportingComponents/TitleH2';
import HeaderLine from './HeaderLine';
import MainTabsContainer from './Tabs/MainTabsContainer';
import Navigator from './Navigator';

import withAuth from '../utils/withAuth';
import { DEFAULT_TAB_SLUG, tabIndexBySlug, LEGACY_TAB_REDIRECTS } from '../utils/cmsTabs';

class MainWrapper extends Component {
  state = {
    activePostCategory: '',
    isSelectingCategory: false,
    activeIndex: -1,
  };

  componentDidMount = () => {
    const {
      getToken,
      history,
      match: {
        params: { postCategory, tab },
      },
    } = this.props;
    if (!getToken()) {
      history.push('/login');
    }
    if (postCategory) this.setState({ activePostCategory: postCategory });
    this.setActiveTabIndex();
  };

  componentDidUpdate = (prevProps) => {
    const {
      match: {
        params: { tab, postCategory },
      },
    } = this.props;
    if (postCategory !== prevProps.match.params.postCategory) {
      this.setState({
        activePostCategory: postCategory,
      });
    }
    if (tab !== prevProps.match.params.tab) {
      this.setActiveTabIndex();
    }
  };

  onCategoryChange = (category, isSelectingCategory) => {
    const { history } = this.props;
    this.setState({ activePostCategory: category, isSelectingCategory });
    if (isSelectingCategory) history.push(`/cms/${DEFAULT_TAB_SLUG}`);
  };

  setActiveTabIndex = () => {
    const {
      history,
      match: {
        params: { tab },
      },
    } = this.props;
    // The tab list lives in utils/cmsTabs, next to the component that renders
    // it. The copy that used to sit here had drifted — it was missing Loyalty,
    // so every later tab resolved one position early and /cms/tickets opened
    // Venues.
    const activeIndex = tabIndexBySlug(tab);
    if (activeIndex === -1 && LEGACY_TAB_REDIRECTS[tab]) {
      // A tab that was folded into another one: keep its bookmarks working.
      history.replace(LEGACY_TAB_REDIRECTS[tab]);
    } else if (activeIndex === -1) {
      history.push(`/cms/${DEFAULT_TAB_SLUG}`);
    } else {
      this.setState({
        activeIndex,
      });
    }
  }

  resetTabs = () => {
    const {
      history,
    } = this.props;
    history.push(`/cms/${DEFAULT_TAB_SLUG}`);
  }

  render() {
    const { isAuth } = this.props;
    const { activePostCategory, isSelectingCategory, activeIndex } = this.state;
    return (
      <>
        {isAuth && (
          <>
            <HeaderLine postCategory={activePostCategory || 'black'} />
            <div className="flex">
              <Navigator />
            </div>
            <div className="flex justify-between mt-4 items-center">
              {activePostCategory ? (
                <>
                  <TitleH2 text={activePostCategory} height="h-10" />
                  <button className="h-10 font-americaMonoBold text-xs px-6 border-black border-1 rounded-full bg-transparent text-black uppercase flex items-center" onClick={() => this.onCategoryChange('', true)} type="button">
                    Change post category
                    <span className="font-icon icon-loading-arrows text-sm pl-2 text-black" />
                  </button>
                </>
              ) : (
                <div className="h-10" />
              )}
            </div>
            {activeIndex !== -1 && <MainTabsContainer activeIndex={activeIndex} handleCategoryChange={this.onCategoryChange} postCategory={activePostCategory} isSelectingCategory={isSelectingCategory} />}
          </>
        )}
      </>
    );
  }
}

MainWrapper.defaultProps = {
  isAuth: null,
};

MainWrapper.propTypes = {
  isAuth: PropTypes.string,
  getToken: PropTypes.func.isRequired,
  history: PropTypes.shape().isRequired,
  match: PropTypes.shape().isRequired,
};

export default withRouter(withAuth(MainWrapper));
